namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeDaysRow {
        Id?: number;
        DiscCouponType?: string;
        PromoDay?: number;
    }

    export namespace PsDiscCouponTypeDaysRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DiscCouponType';
        export const localTextPrefix = 'InitialData.PsDiscCouponTypeDays';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';

        export declare const enum Fields {
            Id = "Id",
            DiscCouponType = "DiscCouponType",
            PromoDay = "PromoDay"
        }
    }
}
